export default "__VITE_ASSET__wm3xXcug__"